import styled, { css } from "styled-components";
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  SIZE,
  MARGIN,
} from "constants/variables";
import { ModalType } from "./ResponsiveModalModel";

export const PopupModal = styled.div<{ open: boolean }>`
  // Common styles

  position: absolute;
  z-index: 1500 !important;
  width: 100vw;
  height: 100vh;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    align-items: center;
    justify-content: center;
  }
  // Media query for landscape screens
  @media screen and (orientation: landscape) {
    width: 100vw;
    height: 100vh;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    display: ${(props) => (props.open ? "flex" : "none")};
    align-items: center;
    justify-content: flex-end;
  }
  // Media query for mobile screens
  @media (orientation: portrait) {
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    transition: left 0.3s ease-in-out;
  }
`;
export const ModalBody = styled.div<{ open: boolean }>`
  margin-top: ${SIZE.max40};
  background: ${COLORS.Cultured};
  border: solid 8px ${COLORS.MetalicSilver};
  right: ${SIZE.max84};
  transition: right 1s ease-in-out;
  box-sizing: border-box;
  height: auto;
  min-height: 300px;
  max-height: 90%;
  z-index: 1500 !important;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    border-bottom: none;
    max-height: 100%;
    height: auto;
    width: 100%;
    max-width: 650px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    position: absolute;

    bottom: 0;
    right: initial;
    left: 50%;
    transform: translateX(-50%);
  }
  height: auto;
  max-width: 400px;
  min-width: 300px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  border-radius: ${BORDER_RADIUS.radius32};
  position: relative;
`;
export const DefibContainer = styled.div`
  height: auto;
  max-height: 100%;
  width: 382px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 100%;
  }
`;
export const AbsolutContainer = styled.div<ModalType>`
  ${({ type }) =>
    type === ModalType.Info &&
    css`
      justify-content: space-between;
    `}
  ${({ type }) =>
    type === ModalType.Defib &&
    css`
      justify-content: flex-end;
    `}
  position: absolute;
  top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 0 16px 0 32px;
  z-index: 100;
`;
export const DefibPhotoContainer = styled.div`
  width: 100%;
  max-height: 300px;
  object-fit: cover;
  background-color: ${COLORS.ChineseSilver};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${BORDER_RADIUS.radius24};
  aspect-ratio: 1/1;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    max-height: 200px;
  }
`;
export const DefibPhotoURL = styled.img`
  border-radius: ${BORDER_RADIUS.radius24};
  height: 100%;
  width: 100%;
  object-fit: cover;
`;
export const DefibPhoto = styled.img`
  height: 100px;
  width: auto;
`;
export const DefibBody = styled.div`
  padding: ${SIZE.fix32};
  height: 100%;
  width: 100%;
`;
export const InformationsContainer = styled.div<{ $extendedShelterDetails?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-height: ${({ $extendedShelterDetails }) => $extendedShelterDetails ? "50vh" : "35vh"};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    max-height: ${({ $extendedShelterDetails }) => $extendedShelterDetails ? "45vh" : "24vh"};
  }
  overflow-y: auto;
`;

export const RedLine = styled.div`
  height: 4px;
  width: 32px;
  background-color: ${COLORS.Crimson};
  margin-top: 4px;
`;
export const DetailsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex: 1;
  width: auto;
  height: 100%;
  margin: ${SIZE.max28} 0;
  > :last-child {
    width: 33%;
  }
`;
export const Schedule = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: ${SIZE.max10} 0;
`;
export const IconWrapper = styled.div`
  > svg {
    height: 24px;
    width: 24px;
  }
`;
export const InformationsFormat = styled.div``;
export const Informations = styled.div`
  margin-top: 5px;
`;
export const ModalActions = styled.div`
  margin-top: ${SIZE.max16};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonWrapper = styled.div`
  width: 176px;
`;
export const PinInfoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: ${SIZE.fix32};
  padding-top: ${SIZE.fix42};
  height: 100%;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const InfoTittleContainer = styled.div`
  width: 100%;
  max-width: 100% !important;

  height: auto;
  margin-top: ${SIZE.max40};
`;
export const PinInfoBody = styled.div``;

export const DsuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.max8};
  margin-top: ${MARGIN.fix16};
  margin-bottom: ${MARGIN.fix32};
  align-items: center;
`;

export const DsuImg = styled.img`
  width: 40px;
  height: 40px;
`;
